import React from 'react';
import { omit } from 'ramda';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import useApp from 'reducers/hooks/useApp';
import { apiErrorsToFormik } from 'utils/errors';

import { Dialog, IconButton, DialogContent } from '@material-ui/core';
import Icon from 'sharedComponents/Icon';
import useScreen from 'hooks/useScreen';
import BuyerRegistrationForm from 'sharedComponents/BuyerRegistrationForm';

import useStyles from './useStyles';

const BuyerRegistration = props => {
  const { onClose, onFinish } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  const { signUp, loadCurrentUser } = useApp();
  const { isMobile } = useScreen();

  const handleSubmit = async (values, { setErrors }) => {
    const attrs = omit('passwordConfirmation', values);
    try {
      await signUp({ ...attrs, userType: 'buyer' });
      onFinish();
      loadCurrentUser();
    } catch (error) {
      const errors = apiErrorsToFormik(error);
      setErrors(errors);
    }
  };

  return (
    <div>
      <Dialog open onClose={onClose} fullScreen={isMobile}>
        <IconButton className={classes.dialogClose} onClick={onClose}>
          <Icon name="bigClose" />
        </IconButton>
        <DialogContent>
          <BuyerRegistrationForm
            onSubmit={handleSubmit}
            buttonLabel={t('components.ReferralRealEstateAgent.BuyerRegistration.buttonLabel')}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

BuyerRegistration.propTypes = {
  onClose: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
};

export default BuyerRegistration;



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/BuyerRegistration/BuyerRegistration.js